module.exports = __webpack_public_path__ + "static/media/ic-current-loc-white.cc048529.svg";